import { useQuery } from "@tanstack/react-query";
import { useBusinessId } from "@/hooks/useBusinessId";
import { getBusinessAddresses } from "@/api/businessAddress";
import { getCurrencyFromCountry } from "@/utils/currency";

/**
 * Returns the business currency (ISO 4217 code) derived from the business's
 * primary address country. Falls back to "USD" while loading or on error.
 */
export function useBusinessCurrency(): string {
  const businessId = useBusinessId();
  const { data } = useQuery({
    queryKey: ["business-addresses", businessId],
    queryFn: () => getBusinessAddresses(businessId),
    enabled: !!businessId,
    staleTime: 5 * 60_000,
  });
  return getCurrencyFromCountry(data?.[0]?.country);
}
